import React from 'react'
import { Route } from 'react-router-dom'

import LevelActivities from './LevelActivities'
import CompletedLevels from './Levels'

const CompletedProTracksIndex = ({ match }) => (
  <div className="completed-protracks-index">
    <Route path={match.path} component={CompletedLevels} exact />
    <Route path={`${match.path}/:protrackId/activity`} component={LevelActivities} />
  </div>
)

export default CompletedProTracksIndex
